import Divider from '@mui/material/Divider';
import { memo } from 'react';
import FuseNavHorizontalLayout1 from './horizontal/FuseNavHorizontalLayout1';
import FuseNavVerticalLayout1 from './vertical/FuseNavVerticalLayout1';
import FuseNavVerticalLayout2 from './vertical/FuseNavVerticalLayout2';
import FuseNavHorizontalCollapse from './horizontal/types/FuseNavHorizontalCollapse';
import FuseNavHorizontalGroup from './horizontal/types/FuseNavHorizontalGroup';
import FuseNavHorizontalItem from './horizontal/types/FuseNavHorizontalItem';
import FuseNavHorizontalLink from './horizontal/types/FuseNavHorizontalLink';
import FuseNavVerticalCollapse from './vertical/types/FuseNavVerticalCollapse';
import FuseNavVerticalGroup from './vertical/types/FuseNavVerticalGroup';
import FuseNavVerticalItem from './vertical/types/FuseNavVerticalItem';
import FuseNavVerticalLink from './vertical/types/FuseNavVerticalLink';
import { registerComponent } from './FuseNavItem';
import PropTypes from 'prop-types';
/*
Register Fuse Navigation Components
 */
registerComponent('vertical-group', FuseNavVerticalGroup);
registerComponent('vertical-collapse', FuseNavVerticalCollapse);
registerComponent('vertical-item', FuseNavVerticalItem);
registerComponent('vertical-link', FuseNavVerticalLink);
registerComponent('horizontal-group', FuseNavHorizontalGroup);
registerComponent('horizontal-collapse', FuseNavHorizontalCollapse);
registerComponent('horizontal-item', FuseNavHorizontalItem);
registerComponent('horizontal-link', FuseNavHorizontalLink);
registerComponent('vertical-divider', () => <Divider className="my-16" />);
registerComponent('horizontal-divider', () => <Divider className="my-16" />);


function FuseNavigation({ layout = 'vertical', navigation, active, dense, className, onItemClick, firstLevel, selectedId }) {
	const options = { navigation, layout, active, dense, className, onItemClick, firstLevel, selectedId };
	if (navigation.length > 0) {
		switch (layout) {
			case 'horizontal': {
				return <FuseNavHorizontalLayout1 {...options} />;
			}
			case 'vertical': {
				return <FuseNavVerticalLayout1 {...options} />;
			}
			case 'vertical-2': {
				return <FuseNavVerticalLayout2 {...options} />;
			}
			default: {
				return <FuseNavVerticalLayout1 {...options} />;
			}
		}
	} else {
		return null;
	}
}

FuseNavigation.propTypes = {
  layout: PropTypes.any,
  navigation: PropTypes.array,
  active: PropTypes.bool,
  dense: PropTypes.bool,
  className: PropTypes.string,
  onItemClick: PropTypes.func,
  firstLevel: PropTypes.any,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default memo(FuseNavigation);
